import '../css/Footer.css';
import { Link } from 'react-router-dom';

const Footer = () => {
  const year = new Date().getFullYear();
  const linkGroups = [
    {
      title: 'Product',
      links: [
        { label: 'Features', to: '/features' },
        { label: 'Pricing', to: '/pricing' },
        { label: 'Documentation', to: '/documentation' },
        { label: 'Newsroom', to: '/news' },
      ],
    },
    {
      title: 'Company',
      links: [
        { label: 'About', to: '/about' },
        { label: 'Support', to: '/support' },
        { label: 'Profile', to: '/profile' },
      ],
    },
    {
      title: 'Legal',
      links: [
        { label: 'Privacy Policy', to: '/privacy' },
        { label: 'Terms of Service', to: '/terms' },
      ],
    },
  ];

  const socialLinks = [
    { label: 'Facebook', href: 'https://www.facebook.com' },
    { label: 'X (Twitter)', href: 'https://www.twitter.com' },
    { label: 'Instagram', href: 'https://www.instagram.com' },
    { label: 'LinkedIn', href: 'https://www.linkedin.com' },
  ];

  return (
    <footer className="footer-shell">
      <div className="footer-inner">
        <div className="footer-brand">
          <h3>BlinkURL</h3>
          <p>
            Shorten links instantly, track real-time clicks, and keep visitors safe with secure preview pages.
          </p>
          <div className="footer-social">
            {socialLinks.map((item) => (
              <a key={item.label} href={item.href} target="_blank" rel="noopener noreferrer">
                {item.label}
              </a>
            ))}
          </div>
        </div>

        <div className="footer-grid">
          {linkGroups.map((group) => (
            <div className="footer-col" key={group.title}>
              <h4>{group.title}</h4>
              {group.links.map((item) => (
                <Link key={item.label} to={item.to}>
                  {item.label}
                </Link>
              ))}
            </div>
          ))}
        </div>

        <div className="footer-cta">
          <h4>Stay in the loop</h4>
          <p>Get product updates, release notes, and growth tips.</p>
          <form>
            <input type="email" placeholder="Email address" />
            <button type="submit">Subscribe</button>
          </form>
        </div>
      </div>

      <div className="footer-bottom">
        <span>© {year} BlinkURL. All rights reserved.</span>
        <div className="footer-bottom-links">
          <Link to="/terms">Terms</Link>
          <Link to="/privacy">Privacy</Link>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
  
